/**
 * Порог близости по умолчанию — средний из доступных: на нём понятия уже собираются в
 * осмысленные кластеры, но ещё различимы. Пустой набор порогов оставляет порог незаданным.
 */
export const defaultThreshold = (thresholds: number[]): number | undefined =>
  thresholds.length === 0 ? undefined : thresholds[Math.floor(thresholds.length / 2)];

/**
 * Набор доступных порогов близости известен только из ответа, поэтому первый запрос страницы
 * уходит без порога и считается без схлопывания понятий — не так, как будет посчитан срез,
 * который страница запросит уже с подставленным порогом. Признак отвечает, применены ли пороги
 * к показанным данным: пока нет, показывать их нельзя — строка и её диалоги разойдутся вплоть
 * до обратного знака влияния. Пустой набор применять нечего: раздел живёт без схлопывания.
 */
export const isThresholdApplied = (available: number[] | undefined, values: (number | undefined)[]): boolean =>
  available !== undefined && (available.length === 0 || values.every((value) => value !== undefined));
